import { useQuery } from "@tanstack/react-query";
import { errorModal } from "modules/error/ErrorHandlingModals";
import { ErrorResponse } from "types";

import { getImportService } from "../api";

export const useGetImportByIdQuery = (importId: string) => {
  return useQuery({
    queryKey: ["getImportById", importId],
    queryFn: () => getImportService(importId),
    onError: (error: ErrorResponse) => errorModal(error),
    suspense: false,
    useErrorBoundary: true
  });
};
